import { render, staticRenderFns } from "./CardMiniProduct.vue?vue&type=template&id=58fefd29&scoped=true&"
import script from "./CardMiniProduct.vue?vue&type=script&lang=js&"
export * from "./CardMiniProduct.vue?vue&type=script&lang=js&"
import style0 from "./CardMiniProduct.vue?vue&type=style&index=0&id=58fefd29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fefd29",
  null
  
)

export default component.exports